import React, { useState, useEffect } from 'react'
import { Fab } from '@mui/material'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'

const FloatingButton: React.FC = () => {
  const [showTopButton, setShowTopButton] = useState(false)
  const [isScrollable, setIsScrollable] = useState(false)

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  const scrollToBottom = () => {
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: 'smooth',
    })
  }

  useEffect(() => {
    const checkScrollability = () => {
      const windowHeight = window.innerHeight
      const documentHeight = document.documentElement.scrollHeight
      setIsScrollable(documentHeight > windowHeight)
    }

    const handleScroll = () => {
      const scrollPosition = window.scrollY
      setShowTopButton(scrollPosition > 100)
      checkScrollability() // Check again in case content height changes
    }

    // Initial check
    checkScrollability()
    handleScroll()

    // Add event listeners
    window.addEventListener('scroll', handleScroll)
    window.addEventListener('resize', checkScrollability)

    return () => {
      window.removeEventListener('scroll', handleScroll)
      window.removeEventListener('resize', checkScrollability)
    }
  }, [])

  if (!isScrollable) return null

  return (
    <Fab
      color='primary'
      aria-label={showTopButton ? 'scroll to top' : 'scroll to bottom'}
      onClick={showTopButton ? scrollToTop : scrollToBottom}
      style={{
        position: 'fixed',
        bottom: '20px',
        left: '100px',
        opacity: 0.8,
      }}
    >
      {showTopButton ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
    </Fab>
  )
}

export default FloatingButton
